import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode } from "vue"

import InputField from '@/components/neue/InputField.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { METHOD_TYPES, sectionCopy } from '@/config/fulfillmentWizardSteps'


export default {
  __name: 'StepMethod',
  setup(__props) {

const wizard = injectWizard()

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('method', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "How customers get their order" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(METHOD_TYPES), (type) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: type.value,
                name: groupName,
                icon: type.icon,
                title: type.label,
                subtitle: type.subtitle,
                selected: _unref(wizard).data.type === type.value,
                onSelect: $event => (_unref(wizard).setType(type.value))
              }, null, 8, ["name", "icon", "title", "subtitle", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16),
    (_unref(wizard).data.type)
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 0 }, _unref(sectionCopy)('name', _unref(wizard).data))), {
          default: _withCtx(() => [
            _createVNode(InputField, {
              "model-value": _unref(wizard).data.name,
              name: "Name",
              placeholder: "e.g. Pickup at the shop",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_unref(wizard).setName($event)))
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ], 64))
}
}

}